import _ from 'lodash'
import { FETCH_VENDORS, CREATE_VENDOR, EDIT_VENDOR, FETCH_VENDOR } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_VENDORS:
      return { ..._.mapKeys(action.payload, 'id') }
    case CREATE_VENDOR:
      return { ...state, ['new_vendor']: action.payload }
    case EDIT_VENDOR:
      return { ...state, [action.payload.id]: action.payload }
    case FETCH_VENDOR:
      return { ...state, [action.payload.id]: action.payload }
    default:
      return state
  }
}
